import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@algomusinc/components';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from '../interceptors/http-interceptor.service';
import { OktaModule } from '@algomusinc/okta';
import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { ServiceModule } from '@algomusinc/services';
import { ToastrModule } from 'ngx-toastr';
import { GlobalErrorHandler } from '../common/GlobalErrorHandler';
import { LoadingBarModule } from '@ngx-loading-bar/core';
const OKTA_DOMAIN = environment.okta.OKTA_DOMAIN; // `dev-30785815.okta.com`;//process.env.DOMAIN;
const CLIENT_ID = environment.okta.CLIENT_ID; // `0oa3dvvdjp3CbK5bg5d7`;//process.env.CLIENT_ID;
const CALLBACK_PATH = environment.okta.CALLBACK_PATH; // '/login/callback';

const AUTHORIZATION_SERVER = environment.okta.AUTHORIZATION_SERVER; // `/oauth2/default`; //`aus3p9jsstzSwf2g95d7`; //`default`;//
const PROTOCOL = environment.okta.PROTOCOL; // `https`;

const ISSUER = environment.okta.addAuthorizationServer
  ? `https://${OKTA_DOMAIN}/${AUTHORIZATION_SERVER}`
  : `https://${OKTA_DOMAIN}`;
const HOST = window.location.host;
const REDIRECT_URI = `${PROTOCOL}://${HOST}${CALLBACK_PATH}`;
const SCOPES = 'openid profile email offline_access';



let okta: any[] = [];
if (environment.okta.enableOkta) {
  const config: OktaAuthOptions = {
    issuer: ISSUER,
    clientId: CLIENT_ID,
    pkce: true,
    redirectUri: REDIRECT_URI,
    scopes: SCOPES.split(/\s+/),
  };

  const oktaAuth = new OktaAuth(config);
  okta = [OktaModule.forRoot(oktaAuth, config)];
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    ServiceModule.forRoot(environment),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    // for Core use:
    LoadingBarModule,
    ServiceWorkerModule.register('service-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:10000',
    }),
    BrowserAnimationsModule,
    ...okta,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    // {
    //   // processes all errors
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandler,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
